import React from "react";
import styles from "./FAQ.module.css";
import LazyLoad from "react-lazyload";

const FirstQuestion = ({ title, questions, images }) => {
  return (
    <div className={styles.container}>
      <div className={styles.faqContainer}>
        <h1 className={styles.QuestionOne}>{title}</h1>

        {questions.map((question, index) => (
          <div key={index} className={styles.firstQuestion}>
            <strong className={styles.header}>{question.header}</strong>
            <p>{question.text}</p>
          </div>
        ))}
      </div>
      <img src={images.default} alt="default" className={styles.image} />

      <img
        src={images.responsive}
        alt="responsive"
        className={styles.imageResponsive}
      />
    </div>
  );
};

export default FirstQuestion;
